import {
  PAYROLL_CARRYOVER_PERIOD,
  PAYROLL_CARRYOVER_LOADING,
  PAYROLL_CARRYOVER_ERROR,
} from '../../actions/types';

const initialState = { incoming: [], outgoing: [], isLoading: false };

export default function PayrollCarryoverReducer(state = initialState, action) {
  switch (action.type) {
    case PAYROLL_CARRYOVER_PERIOD:
      return {
        ...state,
        incoming: action.payload?.incoming || [],
        outgoing: action.payload?.outgoing || [],
        isLoading: false,
      };
    case PAYROLL_CARRYOVER_LOADING:
      return { ...state, isLoading: true };
    case PAYROLL_CARRYOVER_ERROR:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}
